module.exports = __webpack_public_path__ + "static/media/books.20ce6b74.png";